import {
  SIGN_IN_USER_REQUEST_ASYNC,
  SIGN_OUT_USER_REQUEST,
  CLEAN_SIGN_IN_USER_DETAIL,
  SSO_LOGIN_REQUEST_ASYNC,
} from '../constants/constant.action'

export function getUserSignInUserRequest(reqObj) {
  return {
    type: SIGN_IN_USER_REQUEST_ASYNC,
    payload: reqObj,
  }
}

export function ssoLoginRequest(reqObj) {
  return {
    type: SSO_LOGIN_REQUEST_ASYNC,
    payload: reqObj,
  }
}

export function cleanSignInUserDetail() {
  return {
    type: CLEAN_SIGN_IN_USER_DETAIL,
  }
}

export function signOutUserRequest() {
  return {
    type: SIGN_OUT_USER_REQUEST,
  }
}
